import { DateTime } from 'luxon';

export function returnESTDayNumberOnly(timeStamp) {
  const date = DateTime.fromMillis(Number(timeStamp))
    .setZone('America/New_York')
    .toFormat('d');
  return date;
}
